import LeetCode from "../../components/LeetCode/LeetCode";
import "../../styles/main.scss";

const TechPage = ()=> {
    return (
      <div className="main">
        <div className="main__contents">
          <div className="space"></div>
          <div className="main__wrapper">
            <LeetCode />
            <div className="space"></div>
          </div>
        </div>
      </div>
    );
}

export default TechPage;